import { DailyVideo } from '@daily-co/daily-react'
import { cn } from '@quickmd-llc/design-system'
import { type ComponentProps } from 'react'

type Props = Omit<ComponentProps<typeof DailyVideo>, 'type' | 'controls'>

export function DailyVideoSession({ className, ...props }: Props) {
  return <DailyVideo {...props} type='video' className={cn('h-full w-full', className)} controls={false} />
}
